export class WeakPasswordException extends Error {
  constructor(message) {
    super(message);
  }
}
